// src/services/priceService.js
import axios from 'axios';
import { SUPPORTED_TOKENS } from '../config/tokens';

class PriceService {
  constructor() {
    this.baseURL = 'https://api.coingecko.com/api/v3';
    this.cache = new Map();
    this.cacheExpiry = 5 * 60 * 1000; // 5 minutes
  }

  // Token ID mapping for CoinGecko
  getTokenId(symbol) {
  const token = SUPPORTED_TOKENS[symbol];
  return token?.coingeckoId || null;
}

  // Check if cached price is still valid
  isCacheValid(symbol) {
    const cached = this.cache.get(symbol);
    if (!cached) return false;
    return Date.now() - cached.timestamp < this.cacheExpiry;
  }

  // Get single token price
  async getPrice(symbol) {
    // Return cached price if valid
    if (this.isCacheValid(symbol)) {
      return this.cache.get(symbol).price;
    }

    try {
      const tokenId = this.getTokenId(symbol);
      if (!tokenId) throw new Error(`Unknown token: ${symbol}`);

      const response = await axios.get(
        `${this.baseURL}/simple/price?ids=${tokenId}&vs_currencies=usd`,
        {
          timeout: 5000, // 5 second timeout
          headers: {
            'Accept': 'application/json',
          }
        }
      );

      

      const price = response.data[tokenId]?.usd;
      if (!price) throw new Error(`Price not found for ${symbol}`);

      // Cache the price
      this.cache.set(symbol, {
        price: price,
        timestamp: Date.now()
      });

      return price;
    } catch (error) {
      console.error(`Error fetching price for ${symbol}:`, error);
      
      // Return fallback prices if API fails
      const fallbackPrices = {
        'ETH': 3000,
        'USDC': 1,
        'USDT': 1,
        'DAI': 1,
        'MATIC': 0.8
      };
      
      return fallbackPrices[symbol] || 0;
    }
  }

  // Get multiple token prices at once
  async getPrices(symbols) {
    const tokenIds = symbols.map(symbol => this.getTokenId(symbol)).filter(Boolean);
    
    if (tokenIds.length === 0) return {};

    try {
      const response = await axios.get(
        `${this.baseURL}/simple/price?ids=${tokenIds.join(',')}&vs_currencies=usd`,
        {
          timeout: 5000,
          headers: {
            'Accept': 'application/json',
          }
        }
      );

      const prices = {};
      symbols.forEach(symbol => {
        const tokenId = this.getTokenId(symbol);
        const price = response.data[tokenId]?.usd;
        if (price) {
          prices[symbol] = price;
          // Cache individual prices
          this.cache.set(symbol, {
            price: price,
            timestamp: Date.now()
          });
        }
      });
console.log("prices", prices)
      return prices;
    } catch (error) {
      console.error('Error fetching multiple prices:', error);
      return {};
    }
  }

  // Clear cache (useful for testing)
  clearCache() {
    this.cache.clear();
  }
}

// Export singleton instance
export const priceService = new PriceService();
export default priceService;